import _ from 'lodash';
//@ts-ignore
import jQuery from 'jquery';

export const EVENT_FORM_COMPLETED = 'spa-form-completed';
export const EVENT_FORM_ABANDONED = 'spa-form-abandoned';

export const addFormEvent = (
	eventType: string,
	group: string,
	value?: boolean
) => {
	const data = {
		name: eventType,
		action: eventType,
		group: group,
		value,
	};
	addEventInfo({ eventType: 'spa-form-interacted', data });
};

function addEventInfo(event: EventInfo) {
	window.digitalData && window.digitalData.event.push(event);
	// @ts-ignore

	jQuery(document).trigger(event.eventType);
}
